import React, { ReactElement } from 'react';
import { Navigate } from 'react-router-dom';
import { EAuthRoutes } from './shared/constants/constants';
import { getAuthToken } from './utils/authHelpers';

interface PrivateRouteProps {
  children: ReactElement;
}

export const PrivateRoute = ({ children }: PrivateRouteProps) => {
  const authToken = getAuthToken();
  const isAuthenticated = !!authToken?.accessToken;

  return isAuthenticated ? (
    children
  ) : (
    <Navigate replace to={EAuthRoutes.SignIn} />
  );
};
